import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import styled from 'styled-components';
import Hero from '@components/Hero/Hero';
import Projects from '@components/Projects/Projects';
import SkillsExperience from '@components/SkillsExperience/SkillsExperience';
import Contact from '@components/Contact/Contact';
import Modal from '@components/Modal/Modal';
import { GlobalStyle } from '@styles/GlobalStyle';
import metadata from '../../metadata.json';
const packageVersion = metadata.version;
const Container = styled.div `
  max-width: 900px;
  margin: 32px auto;
  background: #fff;
  border-radius: 18px;
  box-shadow: 0 2px 16px rgba(0, 0, 0, 0.07);
  padding: 32px 32px 0 32px;
  position: relative;
  min-height: 100vh;
  overflow: visible;
`;
const AppVersion = styled.div `
    position: absolute;
    bottom: -30px;
    right: 50%;
    font-size: 10px;
    padding: 4px;
    transform: translate(50%);
`;
const App = () => {
    return (_jsxs(_Fragment, { children: [_jsx(GlobalStyle, {}), _jsxs(Container, { children: [_jsx(Hero, {}), _jsxs("main", { children: [_jsx(Projects, {}), _jsx(SkillsExperience, {}), _jsx(Contact, {})] }), _jsx(Modal, {}), _jsxs(AppVersion, { children: ["Version: ", packageVersion] })] })] }));
};
export default App;
